// importando Axios
import axios from 'axios'
//import Router from 'vue-router'
// creacion de la instancia de Axios
const axiosMailUpdate = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
})


//interceptor de Axios para inlcuir el header Authorization
// axiosMailUpdate.interceptors.request.use(
//     function (config) {
//         //const token = localStorage.getItem("token");
//         const token = sessionStorage.getItem("accessToken");
//         if (token) {
//             config.headers.common["Authorization"] = 'Bearer ' + token;
//         } else {
//             delete config.headers.common["Authorization"];
//         }
//         return config;
//     },
//     function (error) {
//         return Promise.reject(error);
//     }
// )
// axiosMailUpdate.interceptors.response.use((response) => {
//     return response;
// }, (error) => {
//     if (error.response.status == 401) {
//         //this.$store.dispatch('destroyToken'),
//         alert('Tu tiempo de sesión expiró')
//         Router.push({
//                 name: 'Page404',
//             })
//     }
//     return Promise.reject(error);
// });

export default axiosMailUpdate